// CLASSES
import AppConfig from "@classes/AppConfig";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}
	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (fields.checkbox_customer_reason_business_relationship.index !== -1) {
		if (fields.checkbox_customer_reason_business_relationship.index === 2 && fields.customer_reason_business_relationship_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	if (fields.checkbox_customer_kyc_purpose.index !== -1) {
		if (fields.checkbox_customer_kyc_purpose.index === 6 && fields.customer_kyc_purpose_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	if (fields.checkbox_customer_kyc_inv.index !== -1) {
		if (fields.checkbox_customer_kyc_inv.index === 2 && fields.customer_kyc_inv_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	if (fields.checkbox_aml_origin.index !== -1) {
		if (fields.checkbox_aml_origin.index === 5 && fields.aml_origin_other_desc.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	if (fields.customer_kyc_sek_invested.length === 0) {
		return false;
	}

	if (fields.kyc_experience_fonder_investments.length === 0) {
		return false;
	}
	if (fields.radio_kyc_knowledge_fonder.options.filter(o => o.checked).length === 0) {
		return false;
	}

	if (fields.radio_customer_pep.options.filter(o => o.checked).length === 0) {
		return false;
	}
	if (!fields.radio_customer_us_person.options[0].checked) {
		return false;
	}
	if (!fields.checkbox_customer_kyc_gdpr.checked) {
		return false;
	}

	/**
	 * Jag förstår riskerna is required but either option is accepted. Even people who don't understand
	 * the risks completely are welcome to open an account.
	 */
	if (!(fields.radio_product_class_a.options[0].checked || fields.radio_product_class_a.options[1].checked)) {
		return false;
	}

	if (fields.checkbox_customer_kyc_empl.index !== -1) {
		if (fields.checkbox_customer_kyc_empl.index === 7 && fields.customer_kyc_empl_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	if (fields.checkbox_customer_kyc_net_income.index === -1) {
		return false;
	}

	if (fields.checkbox_customer_kyc_deposit.index !== -1) {
		if (fields.checkbox_customer_kyc_deposit.index === 7 && fields.customer_kyc_deposit_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	return true;
}



// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/auagfonder/Fields/Fields.fulfillment.js